const SUMMARY_KEY = 'attemptSummary';

export const saveAttemptSummary = candidate => {
    const summary = {
        id: candidate.id,
        name: candidate.name,
        registrationNumber: candidate.registrationNumber,
        subjects: candidate.subjects,
        grade: candidate.grade,
        totalAttempted: candidate.totalAttempted,
        timeSpentInSeconds: candidate.timeSpentInSeconds,
        status: 'Submitted',
        retakeCount: candidate.retakeCount || 0,
        examEnded: candidate.examEnded || false
    };
    try {
        sessionStorage.setItem(SUMMARY_KEY, JSON.stringify(summary));
    } catch (_) {
        // The summary can still be displayed from Redux when storage is unavailable.
    }
};

export const readAttemptSummary = id => {
    try {
        const summary = JSON.parse(sessionStorage.getItem(SUMMARY_KEY));
        return summary?.status === 'Submitted' && String(summary.id) === String(id) ? summary : null;
    } catch (_) {
        return null;
    }
};

export const clearAttemptSummary = () => {
    try {
        sessionStorage.removeItem(SUMMARY_KEY);
    } catch (_) {
        // Storage may be disabled in the browser.
    }
};
